import type { SlaTranslation } from './types';

export const slaAr: SlaTranslation = {
  badge: {
    dueIn: 'الرد مطلوب خلال {{time}}',
    dueSoon: 'الرد مطلوب خلال {{time}}',
    dueNow: 'الرد مطلوب الآن',
    overdue: 'متأخر بمقدار {{time}}',
    paused: 'وقت الرد متوقف',
    outsideHours: 'وقت الرد ينتظر ساعات العمل',
    first_reply: 'الرد الأول',
    next_reply: 'الرد التالي',
    detail: 'هدف {{kind}}: {{target}}.',
  },
  urgent: {
    title: 'عاجلة ولم يأخذها أحد',
    count: '{{n}} عاجلة',
    more: 'يُعرض {{shown}} من {{total}}. الأقرب موعدًا أولًا.',
    claim: 'استلام',
    claimName: 'استلام المحادثة مع {{name}}',
    claimed: 'المحادثة مع {{name}} أصبحت لك الآن.',
    waited: 'تنتظر منذ {{time}}',
    reason: {
      customer_request: 'طلب شخصًا',
      ai_escalated: 'سلّمها الذكاء الاصطناعي',
      ai_unavailable: 'لم يستطع الذكاء الاصطناعي الرد',
      ai_blocked: 'مُنع الذكاء الاصطناعي من الرد',
      ai_limit: 'بلغ الذكاء الاصطناعي حده',
      staff_release: 'أُعيدت إلى قائمة الانتظار',
      channel_ai_off: 'لا يرد الذكاء الاصطناعي على هذه القناة',
      sla_moved: 'نُقلت: لم يرد أحد في الوقت المحدد',
      other: 'تنتظر شخصًا',
    },
  },
  lost: {
    staff: 'أخذ {{name}} هذه المحادثة بالفعل.',
    ai: '{{name}} يرد على هذه المحادثة الآن.',
    external: 'أخذ شخص في Chatwoot هذه المحادثة بالفعل.',
    none: 'غيّر شخص آخر هذه المحادثة أولًا. العرض يُظهر الآن مكانها.',
  },
  settings: {
    title: 'أهداف وقت الرد',
    description:
      'مدى سرعة رد فريقك حسب الأولوية. يُحسب الوقت خلال ساعات العمل أعلاه فقط، ويتوقف أثناء تأجيل المحادثة.',
    guide: 'كيف تعمل أهداف وقت الرد',
    enabled: 'استخدام أهداف وقت الرد لهذه العلامة التجارية',
    enabledHint: 'تُظهر المحادثات التي تنتظر شخصًا موعد الرد، وتنتقل إلى قائمة المتأخرة عندما يتأخر.',
    priority: 'الأولوية',
    firstReply: 'الرد الأول خلال',
    nextReply: 'الرد التالي خلال',
    amount: '{{column}} لأولوية {{priority}}',
    unit: 'وحدة {{column}}، {{priority}}',
    minutes: 'دقائق',
    hours: 'ساعات',
    empty: 'بلا هدف',
    noPriority: 'المحادثات بلا أولوية تستخدم أهداف الأولوية المتوسطة.',
    invalid:
      '{{column}} لأولوية {{priority}}: أدخل عددًا صحيحًا من دقيقة واحدة إلى 7 أيام، أو اتركه فارغًا.',
    save: 'حفظ الأهداف',
    saved: 'حُفظت أهداف وقت الرد لـ {{name}}.',
    overdue: {
      title: 'عندما تتجاوز المحادثة هدفها',
      alertLeads: 'نبّه قادة الفريق فورًا',
      alertLeadsHint:
        'يسمع بها في Studio من يستطيع إسناد المحادثة. ومن ليس متصلًا يصله بريد إلكتروني، مرة واحدة كل 15 دقيقة على الأكثر.',
      move: 'انقلها إذا لم يرد أحد',
      moveHint:
        'تعود إلى قائمة الانتظار، أو إلى الفريق الذي تختاره، وتُعرض على الشخص التالي. لا يُبلَّغ العميل بذلك.',
      after: 'انقلها بعد',
      afterUnit: 'وحدة مدة الانتظار قبل نقلها',
      afterHint: 'تُحسب بساعات العمل بعد تجاوزها هدفها.',
      moveTo: 'انقلها إلى',
      queue: 'قائمة الانتظار (تبقى في فريقها)',
      team: 'فريق {{name}}',
      teamGone: 'فريق لم يعد يستقبل المحادثات',
      invalidAfter: 'انقلها بعد: أدخل عددًا صحيحًا من دقيقة واحدة إلى 7 أيام.',
    },
    loading: 'جارٍ تحميل أهداف وقت الرد',
  },
  moved: 'عادت إلى قائمة الانتظار: لم يرد أحد ضمن هدف وقت الرد.',
};
